import { FilterConfigPassive } from '@/types/filter';
import { getDateRangeFilterOptions } from '../../utils';
import { AppRoutes } from '@/utils/constants';
import { Period, TimePeriod } from '@/types/date';
import dayjs from 'dayjs';
import { getPeriodUntilDate } from '@/utils/date';

const dateRangeFilter: FilterConfigPassive<Period> = {
  label: 'global.filters.formControls.dateRangeLabel',
  options: getDateRangeFilterOptions(),
  defaultValue: getPeriodUntilDate(dayjs(), TimePeriod.YTD),
  type: 'dropdown',
  disabled: ({ contexts: { location } }) => {
    const disabledRoutesForDate = [AppRoutes.PARTNERSCORE, AppRoutes.CESSCORE, AppRoutes.CSATSCORE, AppRoutes.NPSSCORE];
    return disabledRoutesForDate.some(route => route === location?.pathname);
  },
};

export default dateRangeFilter;
